let pos_settings_MenuTag = require("../../templates/pos/settings/MenuTag.handlebars");
//let pos_settings_price = require("../../templates/settings/CreateModifyRecord.handlebars");
let Category = require("../../templates/pos/settings/Category.handlebars");
let Menu_item = require("../../templates/pos/settings/MenuItem.handlebars");
let MenuTag = require("../../templates/pos/settings/MenuTag.handlebars");
let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import i18n from "../../utils/i18n";
import qq from 'fine-uploader'

let PagingView = require("../comp/PagingView.js");
let PagingModel = require("../../model/PagingModel.js");
import ValidationView from "../comp/ValidationView.js";
import POS from "../../POS";
import React from 'react';
import ReactDOM from 'react-dom';
import PackageCreator from "../../react/settings/menu/PackageCreator";

let main = function () {
    return Backbone.View.extend({
        categoryPage: null,
        itemPage: null,
        pageHeight: null,
        validationView: null,
        tagIds: [], //用于暂存编辑中的Tags

        events: {
            "click .cat": "selectCategory",
            "click .newCategory": "showNewCategoryModal",
            "click .newItem": "createItem",
            "click .createCategoryModal .ok": "save",
            "click .editMenu": "showEditCategoryModal",
            "click .item": "selectItem",
            "click .delete": "delete",
            "click .tab-container li": "switchTab",
            "click .addTag": "addTag",
            "click .send-gift": "sendGift",
            "click .addCurrency": "addCurrency",
            "click .deleteCurrency": "removeCurrency",
            "click .removeTag": "removeTag",
            "click .createCategory .removeTag": "removeTag",
            "click .createAllCategory .removeTag": "removeAllTag",
            'click input:checkbox': '_clickCheckbox',
            'click .radio-btn': '_clickRadio',
            'click .addSubitem': 'addSubitem',
            'click .subitemList .editSubitem': 'editSubitem',
            'click .menuHeading .switch': 'showSelectMenuPopup',
            'click .menuHeading .setDefaultMenu': 'setDefaultMenu',
            'click .menuHeading .deleteMenu': 'deleteMenu',
            "click .savecreate": "saveAndCreate",
        },

        initialize: function () {
            if (!this.model) {
                this.model = new Backbone.Model();
            }

            if (this.el) {
                this.model.set({menuId: this.$el.data('id')});
            }

            this.validationView = new ValidationView();
        },

        render: function () {
            this._renderMenu();
            // this.showSelectMenuPopup();
            return this;
        },

        showSelectMenuPopup() {
            console.log("menu list ", this.$el.find("input.menuList").val());
            const reactRoot = this.$el.find(".menuSelector").removeClass('hidden');
            let menuList = this.model.get('menuList');

            if (!menuList) {
                menuList = JSON.parse(this.$el.find("input.menuList").val());
            }

            const self = this;
            ReactDOM.render(
                <MenuSelector
                    menus={menuList}
                    selectedMenu={self.model.get("menu")}
                    onClose={menus => {
                        self.model.set("menuList", menus);
                        reactRoot.addClass('hidden');
                        ReactDOM.unmountComponentAtNode(reactRoot[0]);
                    }}
                    onSelectMenu={this._menuSelected.bind(this)}
                    onNeedRefresh={() => self.trigger("needRefresh")}
                />,
                reactRoot[0]);
        },

        _renderMenu() {
            this.pageHeight = $(window).height() - 100 - this.$('.header').height() - this.$('.paging').height();

            if (!this.categoryPage) {
                this.categoryPage = new PagingView({
                    model: new PagingModel({
                        viewHeight: this.pageHeight,
                        rowSize: 1,
                        rowHeight: 80,
                        itemSize: this.$('.cat-col .pitem').size()
                    }),
                    el: this.$('.cat-col'), pagingControl: this.$('.cat-col .paging')
                }).render();
            }

            if (!this.model.get('currentCategory')) {
                this.selectCategory();

            } else {
                if (this.model.get('currentItem')) {
                    this.renderItem();

                } else {
                    this.renderCategory();
                }
            }

            this.model.set({menu: {id: this.$el.data('id')}});
        },

        // 查询
        _search: function () {
            this._searchMenuInfo();
        },

        // 显示全部
        _searchShowAll: function () {
            // this.$(".memberSearch").val("");
            this.$('.item-col .itemList').show();
            this.$('.item-col .searchlist').remove();
        },

        // 查询餐品
        _searchMenuInfo: function () {
            // console.log("menuid123:",this.model.get('menuId'));
            // console.log("abcmenu:", this.model.get("menu"));
            // 获取查询信息
            var menuSearchName = this.$(".memberSearch").val();
            console.log("menuSearchName123  :", menuSearchName);
            // 如果菜名为空
            if (menuSearchName == "") {
                this._searchShowAll();
                return;
            }

            // ajax
            POS.showLoading(true);
            var rest = POS.getRestaurant();
            var result = $.post('/posMembership/searchMenuItem', {
                restaurantId: rest.id,
                companyId: rest.get('companyId'),
                query: menuSearchName,
                menuid: this.model.get('menuId')
            });

            result.done(function (res) {
                console.log("res123:", res);
                // self.$(".memberSearch").val(menuSearchName);
                // 添加列表
                self.$('.item-col .itemList').hide();
                self.$('.item-col .searchlist').remove();
                self.$('.item-col').append(res);
                self.$(".memberSearch").val("");

                // 清空菜品分类
                // self.$('.catList .cat').hide();
            });
            result.always(function () {
                console.log("res:");
                POS.showLoading(false);
            });


            // 假设拿到了

            // 绑定到界面

        },

        _menuSelected: function (menu) {
            console.log("menu selected", menu);
            if (menu.id === this.model.get('menuId')) {
                return;
            }

            POS.showLoading(true);
            const req = $.post('/pos/settings', {section: 'menu', menuId: menu.id});
            req.done(function (res) {
                POS.showLoading(false);
                this.$el.find('.menuHeading').remove();
                this.$el.find(".menuView").remove();
                this.$el.append(res);
                this.model.set('menuId', menu.id);
                this.categoryPage.remove();
                this.categoryPage = null;
                this.selectCategory(null, true);
                this.$el.find(".menuSelector").addClass('hidden');
                this._renderMenu(true);
            }.bind(this));

            req.fail(function (error) {
                POS.showLoading(false);
                console.log('menu failed to load ', error);
            }.bind(this));
        },

        setDefaultMenu() {
            console.log("set default menu");
            let self = this;
            let menuList = this.model.get('menuList');

            if (this._checkTableStatus()) {
                alert(i18n.msg("pos.checkTableStatus.tip"));
                POS.showLoading(false);
                return false;
            }
            if (!menuList) {
                menuList = JSON.parse(this.$el.find("input.menuList").val());
            }
            POS.showLoading(true);
            const req = $.post("/restaurant/setDefaultMenu", {menuId: this.model.get("menuId"), isDefault: true});
            req.done(res => {
                console.log('menu set default', res);
                if (res.errors) {
                    self._showModalError(res);
                } else if (res.success) {
                    self.trigger("needRefresh");
                    self.$el.find('.menuHeading .setDefaultMenu').addClass("hidden");
                }
            });

            req.fail(res => {
                console.log('failed to set default menu', res);
                self._showModalError(res);
            });
            req.always(res => {
                POS.showLoading(false);
            });
        },

        deleteMenu() {
            const confirmation = confirm("确定要删除" + this.$el.find('.menuHeading .menuName').text() + "吗?"), self = this;

            if (!confirmation) {
                return false;
            }
            let menuList = this.model.get('menuList');

            if (!menuList) {
                menuList = JSON.parse(this.$el.find("input.menuList").val());
            }

            POS.showLoading(true);
            const req = $.post("/restaurant/deleteMenu", {id: this.model.get("menuId"), rid: POS.getRestaurant().id});
            req.done(res => {
                POS.showLoading(false);
                if (res.errors) {
                    self._showModalError(res);
                } else if (res.success) {
                    self.trigger("needRefresh");
                    self._menuSelected(menuList.find(m => m.id !== self.model.get("menuId")));
                }
            });

            req.fail(res => {
                console.log('failed to delete men', res);
                self._showModalError(res);
            });
            req.always(res => {
                POS.showLoading(false);
            });
        },

        _clickCheckbox: function (event) {
            var _this = $(event.currentTarget),
                checkboxDiv = _this.closest('.check-box');
            _this.attr('checked', !_this.attr('checked'));
            checkboxDiv.toggleClass('checkedBox');
        },

        switchTab: function (event) {
            var li = $(event.currentTarget), container = li.closest(".tab-container"), targetTab = li.data("target");
            if (!li.parent().hasClass('nav-tabs')) {
                return;
            }

            const targetTabContainer = container.find(".tab-pane." + targetTab);
            li.addClass('active').siblings('li').removeClass('active');
            container.find(".tab-pane").removeClass("active");
            targetTabContainer.addClass("active");

            if (targetTab === "subitem-tag") {
                var id = this.model.get('currentItem').id, itemList = this.$('.subitemList'),
                    subItemList = this.$('.itemList:not(hidden) [data-parentid=' + id + ']');
                itemList.children().remove();
                if (subItemList.length > 0) {
                    itemList.removeClass("no-sublist");
                    subItemList.each(function (i, item) {
                        var subitem = $(item).clone().removeClass();
                        if (i % 2 == 0) {
                            subitem.addClass("old");
                        }
                        if (!subitem.find('img').length) {
                            subitem.find(".price").before($("<img src='/assets/pos/editSub.png'/>").addClass("editSubitem"));
                        }
                        itemList.append(subitem);
                    });
                } else {
                    itemList.addClass("no-sublist");
                    itemList.append("<li><span>" + i18n.msg('pos.settings.r.sub.desc1') + "</span>" +
                        "</li><li><span>" + i18n.msg('pos.settings.r.sub.desc2') + "</span></li>")
                }
            } else if (targetTab === "packageitem-tag") {
                let currentPackage;
                const currentItem = this.model.get('currentItem');

                if (currentItem) {
                    console.log('pos.getMenu', POS.getMenu(), this.model.get('currentCategory').id);
                    const currentCategory = POS.getMenu().getCategory(this.model.get('currentCategory').id);
                    const menuItem = currentCategory.get('items').find(item => item.id === currentItem.id);

                    if (menuItem && menuItem.package) {
                        currentPackage = menuItem.package;
                    }
                }

                const categories = this.$el.find("li.cat").toArray().map(function (ele) {
                    return {name: ele.dataset.name, id: ele.dataset.id};
                });

                const onSelectCategory = function (catId) {
                    const items = [];
                    this.$el.find(".itemList[data-catid='" + catId + "'] li.pitem").each(
                        function (i, ele) {
                            if (ele.dataset.package === "false") {
                                items.push({
                                    id: ele.dataset.id,
                                    name: ele.getElementsByClassName("name")[0].textContent,
                                    cateId: catId
                                });
                            }
                        });
                    return items;
                }.bind(this);

                ReactDOM.render(<PackageCreator
                        package={currentPackage}
                        categories={categories}
                        onSelectCategory={onSelectCategory}
                        onPackageUpdate={this.packageUpdate.bind(this)}/>,
                    targetTabContainer[0]);

            } else {
            }
        },

        // 渲染菜类12
        renderCategory: function () {
            this.$('.cat').removeClass('selected');
            this.$('.cat[data-id="' + this.model.get('currentCategory').id + '"]').addClass('selected');
            this.$(".itemList").addClass('hidden');
            var itemList = this.$(".itemList[data-catid='" + this.model.get('currentCategory').id + "']");
            this.itemPage = new PagingView({
                model: new PagingModel({
                    viewHeight: this.pageHeight,
                    rowSize: 3,
                    rowHeight: 80,
                    itemSize: itemList.find('.pitem').size()
                }),
                el: itemList, pagingControl: this.$('.item-col .paging')
            }).render();
            itemList.removeClass('hidden');
        },

        packageUpdate: function (packageData) {
            console.log("package data ", packageData);
            this.model.set("package", packageData);
        },

        renderItem: function () {
            var item = this.model.get('currentItem'), currencyPrices;
            this.showItemModal(item.id);
            // if (POS.get('menuItemBytesmap')[item.id]) {
            //     currencyPrices = POS.get('menuItemBytesmap')[item.id].currencyPrices;
            // }
            var modal = this.$('.createCategoryModal');
            modal.find('.modal-title').text(i18n.msg("pos.setting.menu.edititem"));
            modal.find('.itemName').val(item.name);
            modal.find('.shortCode').val(item.shortCode);
            modal.find('.orderIndex').val(item.orderIndex ? item.orderIndex : item.index);
            modal.find('.itemPrice').val(item.price);
            modal.find('.itemDescription').val(item.itemDescription);
            modal.find('.quantitySold').val(item.quantitySold);

            if (this.model.get('subItem')) {
                modal.find("li[data-target='subitem-tag']").hide();
            } else {
                modal.find("li[data-target='subitem-tag']").show();
            }
            var self = this;
            this.tagIds = [];
            var tagsDiv = modal.find(".tags");
            tagsDiv.empty();
            POS.showLoading(true);
            $.post('/menuTag/listByMenuItem', {id: item.id}, function (response) {
                POS.showLoading(false);
                if (response.currencyPrices && response.currencyPrices.length > 0) {
                    var currencyList = modal.find('.currencyList');
                    currencyList.empty();
                    _.each(response.currencyPrices, function (currency, index) {
                        currencyList.append('<li data-itemId="' + item.id + '"><span class="name">' + i18n.msg('pos.printer.receipt.membership.currency.label') + ':' + currency.currencyName + '</span>' +
                            '<span class="price">' + i18n.msg('pos.price') + ':' + currency.currencyPrice + '</span>' +
                            '<span class="glyphicon glyphicon-remove deleteCurrency" data-currencyid=' + currency.currencyId + '></span></li>');
                    });
                }
                _.each(response.tags, function (tag) {
                    var html = pos_settings_MenuTag({tagId: tag.id, tagName: tag.name});
                    tagsDiv.append(html);
                    self.tagIds.push(tag.id);
                });
            });

            //在显示MenuItem时, 加载MenuItem对应的Tag
            if (item.photo) {
                modal.find('.itemPhoto').css('background-image', ('url(/photo/show/' + item.photo + ')'));
            }

            if (item.status == 'SoldOut') {
                self.$(":radio[value='SoldOut']").closest(".radio-btn").addClass("checkedRadio");
                self.$(":radio[value='Available']").closest(".radio-btn").removeClass("checkedRadio");
                // self.$(".forSale-form").hide().val("");
            } else {
                self.$(":radio[value='SoldOut']").closest(".radio-btn").removeClass("checkedRadio");
                self.$(":radio[value='Available']").closest(".radio-btn").addClass("checkedRadio");
                // self.$(".forSale-form").show().find(".forSale").val(item.forSale);
            }
            modal.find('.delete').removeClass('hidden');

            if (modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').removeClass('saveCreate-btn');
            }
            if (!modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').addClass('saveEdit-btn');
            }

            this.model.set({currentModal: 'editItem'});
        },

        selectCategory: function (evt, skipRender) {
            // 显示全部12
            this._searchShowAll();

            if (evt && $(evt.target).hasClass('editMenu')) {
                return;
            }

            var cat = evt ? $(evt.currentTarget) : this.$('li.cat:first'),
                cats = this.$('li.cat'), index = cats.length;
            for (index in cats) {
                if (cat.data("id") == $(cats[index]).data("id")) {
                    break;
                }
            }
            index++;
            console.log("1tempCategory:", cat.data('tempcategory'));
            this.model.set({
                currentCategory: {
                    id: cat.data('id'),
                    name: cat.attr('data-name'),
                    description: cat.attr('data-description'),
                    catIndex: index,
                    hide: cat.data('hide'),
                    posHide: cat.data('poshide'),
                    mobileHide: cat.data('mobilehide'),
                    showBigPiccat: cat.data('showbigbiccat'),
                    tempCategory: cat.data('tempcategory'),
                },
                currentItem: null
            });


            // 显示隐藏添加菜品按钮123
            if (cat.data('tempcategory')) {
                $(".newItem").hide();
            } else {
                $(".newItem").show();
            }

            if (!skipRender) {
                this.render();
            }
        },

        selectItem: function (evt) {
            var item = $(evt.currentTarget),
                itemList = item.closest(".itemList"),
                items = itemList.find(".item"),
                index = items.length;
            for (index in items) {
                if (item.data("id") == $(items[index]).data("id")) {
                    break;
                }
            }
            index++;
            this._showItemEditPanel(item, index);
        },

        _showItemEditPanel: function (item, index) {
            var subitem = {
                id: item.data('id'), name: item.find('.name').text(),
                shortCode: item.find(".shortCode").text(),
                itemDescription: item.find(".itemDescription").text(),
                price: item.attr('data-price'),
                photo: item.attr('data-photo'),
                status: item.find('.menuStatus').text(),
                forSale: item.find('.menuStatus').data("forsale"),
                quantitySold: item.find('.quantitySold').text(),
                ingredients: item.attr('data-ingredients'),
            };
            this.model.unset("subItem");
            if (index < 0) {
                this.model.set({subItem: subitem});
                subitem.parentid = item.data("parentid");
            }

            //TODO 目前orderIndex只用于subitems 有时间应该吧所有排列顺序改成使用 MenuItem.orderIndex
            if (item.data('orderindex') != undefined) {
                subitem.orderIndex = item.data('orderindex') + 1;
            }

            if (item.data('parentid') == undefined && index >= 0) {
                subitem.index = index;
            }
            this.model.set({currentItem: subitem});

            this.render();
        },

        showNewCategoryModal: function () {
            $(".createCategory li:eq(1)").hide();
            $(".savecreate").hide();
            $(".createCategoryModal .ok").show();
            //创建MenuCategory的界面时，清空暂存编辑Tags的Array
            this.tagIds = [];

            var modal = this.$('.createCategoryModal');
            modal.find('.modal-title').text(i18n.msg("pos.setting.menu.newcat"));
            modal.find('.modal-body').empty().append(
                this.$('.createCategory').clone().removeClass('hidden'));
            modal.find('.delete').addClass('hidden');

            if (modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').removeClass('saveEdit-btn');
            }
            if (!modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').addClass('saveCreate-btn');
            }

            modal.modal('show');
            this.model.set({currentModal: 'newCategory'});
        },

        createItem: function (type) {
            //创建MenuItem的界面时，清空暂存编辑Tags的Array
            this.tagIds = [];
            if (type != "sub") {
                this.model.unset("currentItem");
            }
            this.showItemModal(0);
        },

        showItemModal: function (itemId) {
            var currentCat = this.model.get('currentCategory');

            if (!currentCat) {
                alert("请先选择菜单类别");
                return;
            }

            var modal = this.$('.createCategoryModal');
            modal.find('.modal-body').empty();
            var createItem = this.$('.createItem').clone().removeClass('hidden');
            var uploader = new qq.FineUploader({
                element: createItem.find(".upload-wrapper")[0],
                request: {
                    endpoint: '/photo/upload',
                    params: {
                        targetId: itemId ? itemId : 0,
                        type: 'MENU_ITEM'
                    }
                },
                multiple: false,
                callbacks: {
                    onComplete: function (id, fileName, responseJSON) {
                        if (responseJSON.success) {
                            createItem.find(".itemPhoto").css("background-image", "url(" + responseJSON.src + ")");
                            createItem.find(".photo-filename").val(fileName);
                        } else {
                            if (responseJSON.code == 1) {
                                alert(i18n.msg("pos.file.size.over.1m"));
                            }
                        }
                    }
                },
                debug: true,
                validation: {
                    allowedExtensions: ['jpeg', 'jpg', 'gif', 'png']
                },
                text: {
                    uploadButton: createItem.find(".upload-wrapper").text()
                }
            });

            modal.find('.modal-title').text(i18n.msg("pos.setting.menu.newitem") + " " + name);
            modal.find('.modal-body').append(createItem);
            modal.find('.delete').addClass('hidden');
            if (itemId > 0) {
                modal.find("li[data-target='subitem-tag']").show();
                modal.find("li[data-target='currency-tag']").show();
            } else {
                modal.find(".orderIndex").parent().hide();
                modal.find("li[data-target='subitem-tag']").hide();
                modal.find("li[data-target='currency-tag']").hide();
            }
            // can only upload images
            modal.find("input[type='file']").attr('accept', 'image/gif, image/jpeg, image/jpg, image/png');

            if (modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').removeClass('saveEdit-btn');
            }
            if (!modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').addClass('saveCreate-btn');
            }

            modal.modal('show');
            this.model.unset("package");
            this.model.set({currentModal: 'newItem'});
        },

        showEditCategoryModal: function () {
            // this.$('.saveCreate-btn').hide();
            var modal = this.$('.createCategoryModal');
            this.showNewCategoryModal();
            modal.find('.modal-title').text(i18n.msg("pos.setting.menu.editcat"));
            modal.find(".createCategory li:eq(1)").show();//显示餐品分类标签tab
            if (modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').removeClass('saveCreate-btn');
            }
            if (!modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').addClass('saveEdit-btn');
            }
            modal.find('.form-group').removeClass('hidden');
            this.$('.createCategoryModal #catNameInput').val(this.model.get('currentCategory').name);
            this.$('.createCategoryModal #catDescription').val(this.model.get('currentCategory').description);
            this.$('.createCategoryModal #catIndexInput').val(this.model.get('currentCategory').catIndex);
            this.$('.createCategoryModal .hideCategory').prop('checked', this.model.get('currentCategory').hide);
            this.$('.createCategoryModal .hideMobileCategory').prop('checked', this.model.get('currentCategory').mobileHide);
            this.$('.createCategoryModal .hidePosCategory').prop('checked', this.model.get('currentCategory').posHide);
            this.$('.createCategoryModal .showBigPiccat').prop('checked', this.model.get('currentCategory').showBigPiccat);
            // 是否临时分类
            console.log("category:", this.model.get('currentCategory'));
            this.$('.createCategoryModal .isTemCategory').prop('checked', this.model.get('currentCategory').tempCategory);
            if (this.model.get('currentCategory').hide) {
                this.$('.createCategoryModal .hideCategory').closest('.check-box').addClass('checkedBox');
            } else {
                this.$('.createCategoryModal .hideCategory').closest('.check-box').removeClass('checkedBox');
            }
            if (this.model.get('currentCategory').mobileHide) {
                this.$('.createCategoryModal .hideMobileCategory').closest('.check-box').addClass('checkedBox');
            } else {
                this.$('.createCategoryModal .hideMobileCategory').closest('.check-box').removeClass('checkedBox');
            }
            if (this.model.get('currentCategory').posHide) {
                this.$('.createCategoryModal .hidePosCategory').closest('.check-box').addClass('checkedBox');
            } else {
                this.$('.createCategoryModal .hidePosCategory').closest('.check-box').removeClass('checkedBox');
            }
            if (this.model.get('currentCategory').showBigPiccat) {
                this.$('.createCategoryModal .showBigPiccat').closest('.check-box').addClass('checkedBox');
            } else {
                this.$('.createCategoryModal .showBigPiccat').closest('.check-box').removeClass('checkedBox');
            }
            // 临时菜
            if (this.model.get('currentCategory').tempCategory) {
                this.$('.createCategoryModal .isTemCategory').closest('.check-box').addClass('checkedBox');
            } else {
                this.$('.createCategoryModal .isTemCategory').closest('.check-box').removeClass('checkedBox');
            }

            //在显示MenuCategory编辑界面时，加载MenuCategory对应的Tag
            var self = this;
            this.tagIds = [];
            var tagsDiv = modal.find(".tags");
            tagsDiv.empty();
            $.post('/menuTag/listByMenuCategory', {id: this.model.get('currentCategory').id}, function (response) {
                _.each(response.tags, function (tag) {
                    var html = pos_settings_MenuTag({tagId: tag.id, tagName: tag.name});
                    tagsDiv.append(html);
                    self.tagIds.push(tag.id);
                });
            });

            modal.find('.delete').removeClass('hidden');
            this.model.unset("package");
            this.model.set({currentModal: 'editCategory'});
        },

        save: function () {
            var currentModal = this.model.get('currentModal'), currentCat = this.model.get('currentCategory'),
                result, params, self = this;

            this.$('.createCategoryModal .alert-danger').addClass('hidden');

            // 新增菜品分类
            if (currentModal == "newCategory") {
                this.saveNewCategory();

            }
            // 编辑菜品分类
            else if (currentModal == "editCategory") {
                this.editCategory();

            } else if (currentModal == "newItem") {
                this.newItem(0);

            } else if (currentModal = "editItem") {
                this.editItem();
            }
        },

        // 保存并新建
        saveAndCreate: function () {
            this.newItem(1);
        },

        updateMenuItem: function (params, items, prevItem) {
            let self = this, item;
            POS.showLoading(true);
            let result = $.post('/menuItem/updateMenuItem', params);
            result.done(function (res) {
                if (res.success) {
                    if (self.model.get("subItem")) {
                        item = self.$('.sitem[data-id="' + params.id + '"]').attr('data-price', params.price).attr('data-orderindex', params.orderIndex);
                    } else {
                        item = self.$('.pitem[data-id="' + params.id + '"]').attr('data-price', params.price);
                    }

                    item.attr('data-ingredients', params.ingredients);
                    var toIndex = parseInt(self.$(".createCategoryModal .orderIndex").val());
                    var originalIndex = 0;
                    for (var i = 0; i < items.size(); i++) {
                        if (items[i] == item[0]) {
                            originalIndex = i;
                            break;
                        }
                    }
                    if (params.pid != params.id) {
                        item.detach();
                        if (toIndex > originalIndex) {
                            item.insertAfter(prevItem);
                        } else {
                            item.insertBefore(prevItem);
                        }
                    }
                    if (res.menuItem.photo) {
                        item.attr('data-photo', res.menuItem.photo.id);
                    }
                    if (params.status == 'SoldOut') {
                        item.find(".name").siblings("span").remove();
                        item.find(".name").addClass('sold-out');
                        item.find(".name").after("<span>(" + i18n.msg('pos.setting.menu.menuItem.soldOut') + ")</span>");
                    } else {
                        item.find(".name").removeClass('sold-out');
                        item.find(".name").siblings("span").remove();
                    }
                    item.find('.menuStatus').text(params.status);
                    item.find(".shortCode").text(params.shortCode);
                    item.find(".shortCode-wrapper").toggleClass("hidden", !params.shortCode);
                    item.find(".name").text(params.name);
                    item.find(".price").text(POS.getRestaurant().get("currencySymbol") + new Number(params.price).toFixed(2));
                    item.find(".itemDescription").text(params.itemDescription);
                    item.find(".quantitySold").text(params.quantitySold);

                    if (self.model.get("subItem")) {
                        self.$(".item[data-id='" + res.menuItem.parentId + "']").click();
                        self.$(".createCategoryModal .createItem li[data-target='subitem-tag']").click();
                    } else {
                        self.$('.createCategoryModal').modal('hide');
                    }

                    if (res.menuItem && res.menuItem.package) {
                        const currentCategory = POS.getMenu().getCategory(res.menuItem.categoryId);

                        if (currentCategory) {
                            const menuItem = currentCategory.get('items').find(item => item.id === params.id);

                            if (menuItem) {
                                menuItem.package = res.menuItem.package;
                            }
                        }
                    }
                    self.trigger('needRefresh');
                    self.model.unset("subItem");
                } else {
                    self._showModalError(res);
                }
            });

            result.fail(function () {
                console.log('failed to edit menu item');
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        /**
         * 保存对餐品的修改到server
         */
        editItem: function () {
            var currentModal = this.model.get('currentModal'), currentCat = this.model.get('currentCategory'),
                result, params, self = this, index = this.$(".createCategoryModal .orderIndex").val(), pid, prevItem,
                items, item;

            this.validationView = new ValidationView({el: this.$('.createCategoryModal .itemPrice')});

            if (!this.validationView.ge(0).isValid()) {
                this.validationView.render();
                return;
            }
            index = index - 1;

            if (index < 0) {
                index = 0;
            }

            params = {
                orderIndex: index,
                id: this.model.get('currentItem').id,
                name: this.$('.createCategoryModal .itemName').val(),
                price: this.$('.createCategoryModal .itemPrice').val(),
                filename: this.$(".createCategoryModal .photo-filename").val(),
                shortCode: this.$(".createCategoryModal .shortCode").val(),
                itemDescription: this.$(".createCategoryModal .itemDescription").val(),
                ingredients: this.$(".createCategoryModal .ingredients").val(),
                tagIds: this.tagIds.toString(), //提交时加上 Tags 属性
                quantitySold: this.$(".createCategoryModal .quantitySold").val(),
                "Category.id": currentCat.id,
                status: this.$(".createCategoryModal .checkedRadio .menuStatus").val()
            };

            // if (params.status == "Available") {
            //     params.forSale = this.$(".createCategoryModal .forSale-form .forSale").val();
            // }


            if (params.price > 100000) {
                alert(i18n.msg('pos.setting.menu.item.price.large'));
                return;
            }

            if (this.model.get('package')) {
                console.log("update menu item package", this.model.get('package'));
                params['package'] = JSON.stringify(this.model.get('package'));
            }

            items = self.$('.item[data-id="' + params.id + '"]').closest(".itemList").find(".item");

            if (index > items.length - 1) {
                index = items.length - 1;
            }
            prevItem = $(items[index]);
            params.pid = prevItem.data("id");
            self.updateMenuItem(params, items, prevItem);
        },
        _checkTableStatus: function () {
            var result = POS.getTables().filter(function (table) {
                return !table.isEmpty()
            });
            return result.length > 0;
        },
        "delete": function () {
            var currentItem = this.model.get('currentItem'),
                subItem = this.model.get("subItem"), params = {
                    id: currentItem ? currentItem.id : null,
                    menuId: this.model.get('menu').id
                }, catEle = this.$('.cat[data-id="' + this.model.get('currentCategory').id + '"] .number'),
                result, self = this, current, closest;
            POS.showLoading(true);
            if (params.id) {
                if (!confirm(i18n.msg('pos.settings.confirmDelete', currentItem.name))) {
                    POS.showLoading(false);
                    return;
                }
                if (this._checkTableStatus()) {
                    alert(i18n.msg("pos.checkTableStatus.tip"));
                    POS.showLoading(false);
                    return false;
                }
                result = $.post('/menuItem/deleteMenuItem', params);
                result.done(function (res) {
                    if (res.success) {
                        if (subItem) {
                            self.model.unset("subItem");
                            self.$(".item[data-id='" + currentItem.parentid + "']").click();
                            self.$(".createCategoryModal .createItem li[data-target='subitem-tag']").click();
                            var id = self.model.get('currentItem').id,
                                subitemList = self.$('.createCategoryModal .createItem .subitemList');
                            subitemList.find("li[data-id='" + currentItem.id + "']").remove();
                            $(".itemList li[data-id='" + currentItem.id + "']").remove();
                        } else {
                            current = self.$('.item[data-id="' + params.id + '"]');
                            var itemList = current.closest(".itemList");
                            current.remove();
                            self.$('.createCategoryModal').modal('hide');
                            catEle.text(parseInt(catEle.text()) - 1);
                            self.itemPage.render();
                            self.trigger('needRefresh');
                            if (itemList.find(".item").length == 0) {
                                itemList.find(".ech").removeClass("hidden");
                            }
                        }
                    } else {
                        self._showModalError(res);
                    }
                });

            } else {
                params.id = this.model.get('currentCategory').id;

                if (!confirm(i18n.msg('pos.settings.confirmDelete',
                        this.model.get('currentCategory').name))) {
                    POS.showLoading(false);
                    return;
                }

                result = $.post('/menuCategory/delete', params);
                result.done(function (res) {
                    if (res.success) {
                        self.$('li.cat[data-id="' + params.id + '"]').remove();
                        self.$('.itemList[data-catid="' + params.id + '"]').remove();
                        self.$('.createCategoryModal').modal('hide');
                        self.categoryPage.render();
                        self.trigger('needRefresh');
                        if (self.$('.catList .cat').length > 0) {
                            self.$('.catList .cat')[0].click();
                        }
                    } else {
                        self._showModalError(res);
                    }
                });
            }

            result.fail(this._showModalError);
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        saveNewCategory: function () {
            this.validationView = new ValidationView({el: this.$('.createCategoryModal #catNameInput')});

            if (!this.validationView.notEmpty().isValid()) {
                this.validationView.render();
                return;
            }

            var params = {
                    "menu.id": this.model.get('menuId'),
                    name: this.$('.createCategoryModal #catNameInput').val(),
                    description: this.$('.createCategoryModal #catDescription').val(),
                    hide: this.$('.createCategoryModal .hideCategory').prop('checked'),
                    posHide: this.$('.createCategoryModal .hidePosCategory').prop('checked'),
                    mobileHide: this.$('.createCategoryModal .hideMobileCategory').prop('checked'),
                    showBigPiccat: this.$('.createCategoryModal .showBigPiccat').prop('checked'),
                    tempCategory: this.$('.createCategoryModal .isTemCategory').prop('checked'),
                    mid: this.model.get('menuId'),
                    tagIds: this.tagIds.toString() //提交时加上 Tags 属性
                },
                result = $.post('/menuCategory/saveMenuCategory', params),
                self = this;
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    self.$('.createCategoryModal').modal('hide');
                    params.id = res.id;
                    params.size = 0;
                    self.$('.catList').append(
                        Category(params)
                    );
                    self.$(".item-col").append(Menu_item({id: res.id}));
                    self.categoryPage.model.set({itemSize: self.$('.catList .pitem').length});
                    self.categoryPage.render().toLastPage();
                    self.trigger('needRefresh');
                } else {
                    self._showModalError(res);
                }

            });

            result.fail(this._showModalError);
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        editCategory: function () {
            this.validationView.$el = this.$('.createCategoryModal #catNameInput');


            if (!this.validationView.notEmpty().isValid()) {
                this.validationView.render();
                return;
            }

            var currentCat = this.model.get('currentCategory'),
                catIndex = this.$('.createCategoryModal #catIndexInput').val(),
                result, params, cats, pid, prevCat, cat, self = this;

            catIndex = catIndex - 1;
            if (catIndex < 0) {
                catIndex = 0;
            }
            params = {
                id: currentCat.id,
                name: this.$('.createCategoryModal #catNameInput').val(),
                description: this.$('.createCategoryModal #catDescription').val(),
                catIndex: catIndex,
                hide: this.$('.createCategoryModal .hideCategory').closest('.check-box').hasClass('checkedBox'),
                posHide: this.$('.createCategoryModal .hidePosCategory').closest('.check-box').hasClass('checkedBox'),
                mobileHide: this.$('.createCategoryModal .hideMobileCategory').closest('.check-box').hasClass('checkedBox'),
                showBigPiccat: this.$('.createCategoryModal .showBigPiccat').closest('.check-box').hasClass('checkedBox'),
                tempCategory: this.$('.createCategoryModal .isTemCategory').prop('checked'),
                menuId: this.model.get('menu').id,
                tagIds: this.tagIds.toString() //提交时加上 Tags 属性
            };
            cats = self.$('.catList').find('li.cat');
            if (catIndex > cats.length - 1) {
                catIndex = cats.length - 1;
            }
            prevCat = $(cats[catIndex]);

            params.pid = prevCat.data("id");
            cat = self.$('li.cat[data-id="' + params.id + '"]');
            result = $.post('/menuCategory/update', params);
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    self.$('.cat[data-id="' + params.id + '"]').attr('data-name', params.name).attr('data-hide', params.hide).attr('data-description', params.description)
                        .find('.name').text(params.name).find('.number').text(self.$('.itemList[data-catid="' + params.id + '"] .item').size());
                    var toIndex = parseInt(self.$(".createCategoryModal #catIndexInput").val());
                    var originalIndex = 0;
                    for (var i = 0; i < cats.size(); i++) {
                        if (cats[i] == cats[0]) {
                            originalIndex = i;
                            break;
                        }
                    }
                    if (params.pid != params.id) {
                        cat.detach();
                        if (toIndex > originalIndex) {
                            cat.insertAfter(prevCat);
                        } else {
                            cat.insertBefore(prevCat);
                        }
                    }
                    self.$('.createCategoryModal').modal('hide');
                    currentCat.name = params.name;
                    currentCat.description = params.description;
                    currentCat.hide = params.hide;
                    currentCat.posHide = params.posHide;
                    currentCat.mobileHide = params.mobileHide;
                    currentCat.showBigPiccat = params.showBigPiccat;
                    self.model.set({
                        currentCategory: {
                            id: params.id,
                            name: params.name,
                            description: params.description,
                            hide: params.hide,
                            posHide: params.posHide,
                            mobileHide: params.mobileHide,
                            showBigPiccat: params.showBigPiccat
                        }
                    });
                    self.trigger('needRefresh');

                } else {
                    self._showModalError(res);
                }

            });

            result.fail(this._showModalError);
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        newItem: function (type) {
            $(".createCategoryModal .ok").show();
            this.validationView = new ValidationView({el: this.$('.createCategoryModal .itemName')});

            if (!this.validationView.notEmpty().isValid()) {
                this.validationView.render();
                return;
            }

            this.validationView = new ValidationView({el: this.$('.createCategoryModal .itemPrice')});

            if (!this.validationView.ge(0).isValid()) {
                this.validationView.render();
                return;
            }

            this.$('button.ok').attr('disabled', 'disabled');

            var currentCat = this.model.get('currentCategory'),
                params = {
                    "category.id": currentCat.id,
                    name: this.$('.createCategoryModal .itemName').val(),
                    price: this.$('.createCategoryModal .itemPrice').val(),
                    filename: this.$(".createCategoryModal .photo-filename").val(),
                    shortCode: this.$(".createCategoryModal .shortCode").val(),
                    itemDescription: $(".createCategoryModal .itemDescription").val(),
                    quantitySold: $(".createCategoryModal .quantitySold").val(),
                    mid: this.model.get('menuId'),
                    status: this.$(".createCategoryModal .checkedRadio .menuStatus").val(),
                    tagIds: this.tagIds.toString(),  //提交时加上 Tags 属性
                },
                catEle = this.$('.cat[data-id="' + currentCat.id + '"] .number'),
                self = this;
            // if (params.status == "Available") {
            //     params.forSale = this.$(".createCategoryModal .forSale-form .forSale").val();
            // }
            if (this.model.get('currentItem')) {
                params['parentItemId'] = this.model.get('currentItem').id;
            }

            console.log("saving menu item package", this.model.get('package'));
            params['package'] = JSON.stringify(this.model.get('package'));
            var result = $.post('/menuItem/saveMenuItem', params);
            if (params.price > 100000) {
                alert(i18n.msg('pos.setting.menu.item.price.large'));
                return;
            }

            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    console.log('item added');
                    if (self.model.get('currentItem')) {
                        self.$(".item[data-id='" + self.model.get('currentItem').id + "']").click();
                        self.$(".createCategoryModal .createItem li[data-target='subitem-tag']").click();
//                            var sublist = self.$(".modal .createItem li[data-target='subitem-tag']").find(".subitemList");
                        var id = self.model.get('currentItem').id,
                            itemList = self.$('.createCategoryModal .createItem .subitemList'),
                            subitem = self.$(".itemList[data-catid='" + currentCat.id + "'] .item").first();
                        subitem = subitem.clone().removeClass();
                        subitem.attr("data-parentid", self.model.get('currentItem').id);
                        subitem.attr('data-id', res.menuItem.id);
                        subitem.find(".shortCode").text(params.shortCode);
                        subitem.find(".shortCode-wrapper").toggleClass("hidden", !params.shortCode);
                        subitem.addClass("sitem");
                        subitem.find('.name').text(params.name);
                        subitem.find('.price').text(POS.getRestaurant().get("currencySymbol") + new Number(params.price).toFixed(2));
                        subitem.attr('data-price', params.price);
                        subitem.find('.menuStatus').text(params.status);

                        if (itemList.hasClass("no-sublist")) {
                            itemList.removeClass("no-sublist");
                            itemList.empty();
                        }
                        if (itemList.find("li") % 2 == 0) {
                            subitem.addClass('old');
                        }
                        if (params.status == 'SoldOut') {
                            subitem.find(".name").siblings("span").remove();
                            subitem.find(".name").addClass('sold-out');
                            subitem.find(".name").after("<span class='sold-out-labe'>(" + i18n.msg('pos.setting.menu.menuItem.soldOut') + ")</span>");
                        } else {
                            subitem.find(".name").removeClass('sold-out');
                            subitem.find(".name").siblings("span").remove();
                        }
                        subitem.find(".price").before($("<img src='/assets/pos/editSub.png'/>").addClass("editSubitem"));
                        itemList.append(subitem);
                        var subItemInList = subitem.clone();
                        subItemInList.addClass('hidden');
                        subItemInList.addClass('item');
                        self.$(".itemList[data-catid='" + currentCat.id + "']").append(subItemInList);
                        subitem.attr('data-ingredients', params.ingredients);
                    } else {
                        var item = self.$('.item:not(".hidden")').first().clone().attr('data-price', params.price).attr('data-id', res.menuItem.id);
                        if (res.menuItem.photo) {
                            item.attr('data-photo', res.menuItem.photo.id);
                        }
                        item.find(".shortCode").text(params.shortCode);
                        item.find(".shortCode-wrapper").toggleClass("hidden", !params.shortCode);
                        item.find(".name").text(params.name).removeClass('sold-out');
                        item.find(".price").text(POS.getRestaurant().get("currencySymbol") + new Number(params.price).toFixed(2));
                        item.find(".itemDescription").text(params.itemDescription);
                        item.find(".menuStatus").text(params.status);
                        item.find('.quantitySold').text(params.quantitySold);
                        if (params.status == 'SoldOut') {
                            item.find(".name").siblings("span").remove();
                            item.find(".name").addClass('sold-out');
                            item.find(".name").after("<span class='sold-out-labe'>(" + i18n.msg('pos.setting.menu.menuItem.soldOut') + ")</span>");
                        } else {
                            item.find(".name").removeClass('sold-out');
                            item.find(".name").siblings("span").remove();
                        }
                        self.$('.itemList[data-catid="' + currentCat.id + '"]').append(item);
                        self.itemPage.render();
                        catEle.text(parseInt(catEle.text()) + 1);
                        self.trigger('needRefresh');
                        self.$('.createCategoryModal').modal('hide');
                        item.closest(".itemList").find(".ech").addClass("hidden");
                        //self.$('.itemList[data-catid="' + currentCat.id + '"]').find('.pitem').each(function (i, item) {
                        //    if ($(item).data('parentid')) {
                        //        $(item).addClass('hidden');
                        //    }
                        //});

                        if (res.menuItem && res.menuItem.package) {
                            const currentCategory = POS.getMenu().getCategory(res.menuItem.categoryId);

                            if (currentCategory) {
                                const items = currentCategory.get('items');
                                currentCategory.set({items: items.concat(res.menuItem.package)});
                            }
                        }

                        // 如果是保存并新建
                        if (type == 1) {
                            self.createItem();
                        }
                    }
                } else {
                    self._showModalError(res);
                }

            });

            result.fail(this._showModalError);
            result.always(function () {
                self.$('button.ok').attr('disabled', null);
                POS.showLoading(false);
            })

        },

        _showModalError: function (res) {
            console.log(res);
            this.$('.createCategoryModal .alert-danger').removeClass('hidden').text(
                res.errors ? (_.isObject(res.errors) ? JSON.stringify(res.errors) : res.errors) : i18n.msg["pos.serverError"]);
        },

        removeCurrency: function (evt) {
            var self = this, current = $(evt.currentTarget), jxhr;
            var params = {
                itemId: this.model.get('currentItem').id,
                currencyId: current.data('currencyid')
            };
            jxhr = $.post('/menuItem/removeCurrencyPrice', params);
            POS.showLoading(true);
            jxhr.done(function (res) {
                if (res.success) {
                    current.closest('li').remove();
                    POS.get('menuItemBytesmap')[params.itemId] = res.menuItem.bytesmap;
                    self.trigger('needRefresh');
                }
            });
            jxhr.always(function (res) {
                POS.showLoading(false);
            });
            return;
        },

        addCurrency: function (evt) {
            var self = this, current = $(evt.currentTarget), jxhr;
            var currencyList = current.closest('.currency-tag').find('.currencyList');
            var params = {
                itemId: this.model.get('currentItem').id,
                price: current.siblings('.currency-price').val(),
                currencyId: current.siblings('.currency-select').val()
            };
            if (!params.price || params.price < 0 || params.price > 99999) {
                alert(i18n.msg('pos.setting.menu.item.price.large'));
                return false;
            }
            jxhr = $.post('/menuItem/createCurrencyPrice', params);
            POS.showLoading(true);
            jxhr.done(function (res) {
                if (res.success) {
                    currencyList.empty();
                    POS.get('menuItemBytesmap')[params.itemId] = res.menuItem.bytesmap;
                    _.each(res.menuItem.currencyPrices, function (currency, index) {
                        currencyList.append('<li data-itemId="' + params.itemId + '"><span class="name">' + i18n.msg('pos.printer.receipt.membership.currency.label') + ':' + currency.currencyName + '</span>' +
                            '<span class="price">' + i18n.msg('pos.price') + ':' + currency.currencyPrice + '</span>' +
                            '<span class="glyphicon glyphicon-remove deleteCurrency" data-currencyid=' + currency.currencyId + '></span></li>');
                    });
                    self.trigger('needRefresh');
                } else if (res.exist) {
                    alert(i18n.msg('pos.quickSetting.menu.itemexist'));
                }

            });
            jxhr.fail(function (res) {

            });
            jxhr.always(function (response) {
                POS.showLoading(false);
            });
            return;
        },

        /*
         * 赠送礼物
         */
        sendGift: function (evt) {
            var target = $(evt.currentTarget);
            var self = this, jxhr, memberInfo = target.closest('.addTagRow').find('.giftname').val();
            if (!memberInfo || memberInfo == "") {
                alert("请输入会员卡号或手机号");
                return false;
            }
            var params = {
                memberInfo: memberInfo,
                menuItemId: self.model.get("currentItem").id,
                quantity: "1",
                restaurantId: POS.getRestaurant().id
            };
            POS.showLoading(true);
            jxhr = $.post('/menuItemGift/sendGift', params);
            jxhr.done(function (response) {
                if (!response.success) {
                    if (response.errorMsg) {
                        alert(response.errorMsg);
                    }
                } else {
                    alert("礼物赠送成功");
                }
            });
            jxhr.fail(function (response) {
            });
            jxhr.always(function () {
                POS.showLoading(false);
            })

        },

        /*
         * 添加Tag
         */
        addTag: function (evt) {
            var self = this;
            var parentElem = $(evt.target).closest('.menuItem-tag');
            var tagName = parentElem.find('.tagName').val().trim();
            if (tagName.length == 0) {
                alert(i18n.msg('pos.settings.tag.name.empty.error'));
                parentElem.find('.tagName').focus();
                return false;
            }
            if (parentElem.find("[data-tag-name='" + tagName + "']").length > 0) {
                alert(i18n.msg('pos.settings.tag.name.conflict.error'));
                parentElem.find('.tagName').focus();
                return false;
            }
            if (tagName.length > 20) {
                alert(i18n.msg('pos.settings.tag.name.length.error'));
                parentElem.find('.tagName').focus();
                return false;
            }

            var params = {rId: POS.getRestaurant().get("id"), tagName: tagName};
            var result = $.post('/menuTag/create', params);
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    parentElem.find('.tagName').val("");
                    if (parentElem.find("[data-id=" + res.tagId + "]").length == 0) {
                        var html = MenuTag(res);
                        parentElem.find(".tags").append(html);
                        //将tagId加到tagIds的Array
                        self.tagIds.push(res.tagId);
                    }
                }
            });
            result.always(function (response) {
                POS.showLoading(false);
            });

        },

        /*
         * 删除Tag
         */
        removeTag: function (evt) {
            var self = this,
                button = $(evt.currentTarget),
                id = button.data("id");
            console.log("button.data(tagName):", button.data("tagName"));
            if (!confirm(i18n.msg("pos.settings.confirm.delete.tag", button.data("tagName").toString()))) {
                return false;
            }
            button.remove();
            //移除删除的tagId
            self.tagIds.splice(self.tagIds.indexOf(id), 1)
        },
        _clickRadio: function (event) {
            var _this = $(event.currentTarget),
                block = _this.closest(".form-group");
            block.find('input:radio').attr('checked', false);
            block.find(".radio-btn").removeClass('checkedRadio');
            _this.addClass('checkedRadio');
            _this.find('input:radio').attr('checked', true);
            if (_this.find(".menuStatus")) {
                // if (_this.find(".menuStatus").val() == "SoldOut") {
                //     this.$(".forSale-form").hide();
                // } else {
                //     this.$(".forSale-form").show();
                // }
            }
        },

        addModifyPriceRecord: function () {

        },

        addSubitem: function () {
            this.$('.createCategoryModal').modal('hide');
            console.log(this.model.get('currentItem'));
            this.createItem("sub");
        },

        editSubitem: function (evt) {
            var item = $(evt.target).closest('li');
            this._showItemEditPanel(item, -1);
        }
    });
};

let exportedValue = main();

export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/MenuSettingView.js